// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2yCtk","row":"styles_row__3P_F0"};